"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DEFAULT_TEXT_COLOR = exports.DEFAULT_BUTTON_COLOR = exports.DEFAULT_FONT_SIZE = exports.PILL = exports.OUTLINED = exports.RECTANGLE = exports.ROUNDED = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ROUNDED = 'rounded';
exports.ROUNDED = ROUNDED;
var RECTANGLE = 'rectangle';
exports.RECTANGLE = RECTANGLE;
var OUTLINED = 'outlined';
exports.OUTLINED = OUTLINED;
var PILL = 'pill';
exports.PILL = PILL;
var DEFAULT_FONT_SIZE = 18;
exports.DEFAULT_FONT_SIZE = DEFAULT_FONT_SIZE;
var DEFAULT_BUTTON_COLOR = '#0075FF';
exports.DEFAULT_BUTTON_COLOR = DEFAULT_BUTTON_COLOR;
var DEFAULT_TEXT_COLOR = '#FFFFFF';
exports.DEFAULT_TEXT_COLOR = DEFAULT_TEXT_COLOR;
var FONT_SIZE_MIN = 8;
var FONT_SIZE_MAX = 96; // eslint-disable-next-line consistent-return

var validFontSize = (props, propName, componentName) => {
  if (props[propName] < FONT_SIZE_MIN || props[propName] > FONT_SIZE_MAX) {
    return new Error("Invalid ".concat(propName, " of ").concat(props[propName], " supplied to ").concat(componentName, "."));
  }
};

var useStyles = (0, _styles.makeStyles)({
  container: {
    width: 'inherit',
    height: 'inherit',
    fontWeight: 'normal',
    textTransform: 'none',
    overflow: 'hidden'
  }
}, {
  name: 'Mui-WidgetButton'
});

var Button = (_ref) => {
  var {
    icon,
    text,
    font: fontFamily = 'Helvetica Neue',
    fontSize = DEFAULT_FONT_SIZE,
    bold = true,
    italic = false,
    underline = false,
    style = ROUNDED,
    color = DEFAULT_BUTTON_COLOR,
    textColor = DEFAULT_TEXT_COLOR,
    url,
    onClick,
    external
  } = _ref;
  var classes = useStyles();

  var handleClick = event => {
    event.preventDefault();
    return onClick && onClick(event);
  };

  var borderRadius;

  if (style === RECTANGLE) {
    borderRadius = 0;
  } else if (style === PILL) {
    borderRadius = '999em'; // allow radii to overlap to create pill shape
  }

  return /*#__PURE__*/_react.default.createElement(_Button.default, {
    component: "a",
    href: url,
    className: classes.container,
    startIcon: icon ? /*#__PURE__*/_react.default.cloneElement(icon, {
      style: {
        fontSize
      }
    }) : null,
    endIcon: external ? /*#__PURE__*/_react.default.cloneElement(external, {
      style: {
        fontSize
      }
    }) : null,
    disableElevation: true,
    fullWidth: true,
    onClick: handleClick,
    variant: style === OUTLINED ? 'outlined' : 'contained',
    style: {
      backgroundColor: style === OUTLINED ? 'transparent' : color,
      border: style === OUTLINED && "2px ".concat(color, " solid"),
      color: textColor,
      borderRadius,
      fontFamily,
      fontSize,
      fontStyle: italic && 'italic',
      fontWeight: bold && '700',
      textDecoration: underline && 'underline'
    }
  }, text);
};

Button.propTypes = {
  /**
   * Icon component
   */
  icon: _propTypes.default.node,

  /**
   * Button label text
   */
  text: _propTypes.default.string,

  /**
   * Font family for button label
   */
  font: _propTypes.default.string,

  /**
   * Font size for button text
   */
  fontSize: validFontSize,

  /**
   * If button label should be bolded
   */
  bold: _propTypes.default.bool,

  /**
   * If button label should be italicized
   */
  italic: _propTypes.default.bool,

  /**
   * If button label should be underlined
   */
  underline: _propTypes.default.bool,

  /**
   * Button background color
   */
  color: _propTypes.default.string,

  /**
   * Button label's text color
   */
  textColor: _propTypes.default.string,

  /**
   * Choose between stretch or center for placing the image
   */
  style: _propTypes.default.oneOf([ROUNDED, RECTANGLE, OUTLINED, PILL]),

  /**
   * Passed as href to the button
   */
  url: _propTypes.default.string,

  /**
   * Callback function will be triggered when clicked
   */
  onClick: _propTypes.default.func,

  /**
   * If button should show external link icon component
   */
  external: _propTypes.default.node
};
var _default = Button;
exports.default = _default;